import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import styled from 'styled-components';
import { theme, media, color } from '../theme';
import { vr } from '../utils';

const navTitleMaxLength = 46;
export const navHorizontalMargin = '2rem';
export const navVerticalOffset = vr(3.5);

const newsQuery = graphql`
  query HorizontalNewsPosts{
    news: allMdx(
      sort: {
        fields: [frontmatter___date],
        order: DESC
      },
      filter: {
        id: {
          ne: "ede6c553-ffb1-55a3-b55a-f6f0cc1554dc",
        },
        frontmatter: {
          templateKey: {eq: "news-post"},
        },
      },
      limit: 4
    ) {
      edges {
        post: node {
          id
          fields {
            slug
          }
          frontmatter {
            title
          }
        }
      }
    }
  }
`;

export function HorizontalNewsBar() {
  const data = useStaticQuery(newsQuery);
  const news = data.news.edges;

  if (news.length === 0) return null;

  return (
    <div className="nav container">
      <Nav>
        {news.map(({ post: { id, fields: { slug: link }, frontmatter: { title } } }) => (
          <li key={id}>
            <a href={link} title={title}>
              {title.length > navTitleMaxLength ? `${title.substring(0, navTitleMaxLength - 3)}...` : title}
            </a>
          </li>
        ))}
      </Nav>
    </div>
  );
}

const Nav = styled.ul`
  bottom: 0;
  z-index: 100;
  box-sizing: border-box;
  box-shadow: ${theme.containerShadow};
  background: ${color.white};
  display: none;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border: 4px solid transparent;
  padding: 2rem;
  margin: 0 ${navHorizontalMargin};
  list-style: none;

  @media ${media.landscapeL} {
    display: flex;
  }

  &, * {
    height: auto;
  }

  li {
    flex: 1;

    a {
      color: ${color.brown};
      text-decoration: none;
      display: block;
      padding-right: 1rem;
      font-size: .8rem;
      height: 100%;

      &:hover {
        color: ${theme.navItemColorFocus};
      }

      @media ${media.tabletM} {
        font-size: .9rem;
      }
    }

    &:nth-child(1n+6) {
      display: none;
    }
  }
`;
